import HistoricalRecord from './HistoricalRecord';
export default HistoricalRecord;
